import { useQueryClient } from "@tanstack/react-query";
import { FinancialProposal } from "../../types";
import { EditProposalDto } from "../../dtos/rental-financial-proposal";
import { editProposal } from "../../api/rental-financial-proposal";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditProposal() {
  const queryClient = useQueryClient();

  const mutation = useDomainMutation<
    AxiosResponse<FinancialProposal>,
    { response?: { data?: { message?: string } } },
    { data: EditProposalDto }
  >({
    mutationFn: ({ data }: { data: EditProposalDto }) => {
      return editProposal(data);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["financial-proposals"] });
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutation;
}
